
<p v-if="objectModelTrigger.mapping_id">
  Run
  <a :href="RouteHelper.path({route: Route.editMapping, modelOrId: objectModelTrigger.mapping_id})" class="btn-link">
    {{objectModelTrigger.mapping_title}}
  </a>
</p>
